// Keep aligned with CLIENT_PHOTO_POLICY and the client-photo nginx include.
export const CLIENT_PHOTO_MAX_BYTES = 2000000;
export const CLIENT_PHOTO_TOTAL_BYTES = 10000000;
export const CLIENT_PHOTO_MAX_FILES = 10;
export const CLIENT_PHOTO_UPLOAD_HELP = 'Choose up to 10 JPEG, PNG, WebP or HEIC/HEIF photos, 2 MB each and 10 MB total.';

export const clientPhotoMime = file => {
  if (file.type && file.type !== 'application/octet-stream') return file.type;
  const ext = (file.name || '').split('.').pop().toLowerCase();
  return ext === 'heic' || ext === 'heif' ? `image/${ext}` : file.type;
};
export const isHeifPhoto = file => ['image/heic', 'image/heif'].includes(clientPhotoMime(file));
export const isPdfGalleryRecord = record => record?.content_type === 'application/pdf' || /\.pdf$/i.test(record?.original_filename || record?.photo || '');

export const validateClientPhotoSelection = (files) => {
  if (!Array.isArray(files) || !files.length) return 'Choose at least one photo.';
  if (files.length > CLIENT_PHOTO_MAX_FILES) return 'Choose no more than 10 photos.';
  if (files.some(file => !['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'].includes(clientPhotoMime(file)))) return 'Choose JPEG or PNG photos, WebP, or HEIC/HEIF photos.';
  if (files.some(file => !Number.isFinite(file.size) || file.size <= 0)) return 'Choose a non-empty JPEG or PNG photo.';
  if (files.some(file => isHeifPhoto(file) && file.size > CLIENT_PHOTO_MAX_BYTES)) return 'HEIC/HEIF photos must be no larger than 2 MB. Export a smaller photo or a JPEG and try again.';
  return null;
};

export const validateClientPhotoUpload = (files) => {
  const selectionError = validateClientPhotoSelection(files);
  if (selectionError) return selectionError;
  if (files.some(file => file.size > CLIENT_PHOTO_MAX_BYTES)) return 'Each photo must be no larger than 2 MB.';
  if (files.reduce((sum, file) => sum + file.size, 0) > CLIENT_PHOTO_TOTAL_BYTES) return 'Photos must total no more than 10 MB. Upload fewer photos at a time.';
  return null;
};
